export default "__VITE_ASSET__Ci6Q4xxF__"